import { post, notifier } from '../util';
import { setSyncEnabled } from './crosshair-sync';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const SortableModule = require('sortablejs');
const Sortable = SortableModule.default || SortableModule;

export function initSortable(): void {
    const container = document.querySelector('.col-charts') as HTMLElement;
    if (!container) return;

    const sortable = new Sortable(container, {
        draggable: '.chart-wrapper',
        handle: '.chart-drag-handle',
        animation: 200,
        ghostClass: 'chart-wrapper--ghost',
        chosenClass: 'chart-wrapper--chosen',
        dragClass: 'chart-wrapper--dragging',
        delay: 300,
        delayOnTouchOnly: true,
        touchStartThreshold: 4,
        onStart: function () {
            setSyncEnabled(false);
            if (navigator.vibrate) {
                navigator.vibrate(50);
            }
        },
        onEnd: function (evt: any) {
            setSyncEnabled(true);
            const order = sortable.toArray();
            saveOrder(order);
            if (evt.item) {
                flashCard(evt.item);
            }
        }
    });
}

function saveOrder(order: string[]): void {
    post('?do=saveGraphOrder&order=' + encodeURIComponent(order.join(',')), {}, (data: any) => {
        if (data.status !== 1) {
            notifier.alert('Failed to save graph order');
        }
    });
}

function flashCard(item: HTMLElement): void {
    item.classList.add('chart-wrapper--dropped');
    setTimeout(() => item.classList.remove('chart-wrapper--dropped'), 600);
}
